/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview This file contains the Multicolumn class and related utilities
 * for managing "Read more/Read less" functionality in a multi-column layout.
 */

// Constants for DOM selectors
var SELECTORS = {
  TRIGGER: '[js-trigger]',
  TRUNCATE: '[js-truncate]'
};

// CSS classes used for toggling visibility
var CLASSES = {
  HIDDEN: 'hidden'
};

// Data attributes used for identifying and manipulating elements
var ATTRIBUTES = {
  TRIGGER: 'js-trigger',
  TRUNCATE: 'js-truncate',
  ARIA_HIDDEN: 'aria-hidden'
};

// Text constants for the toggle button
var TEXT = {
  READ_MORE: 'Read more',
  READ_LESS: 'Read less'
};

/**
 * Toggles between "Read more" and "Read less" text.
 * @param {string} text - The current text of the toggle button.
 * @returns {string} The toggled text.
 */
var toggleText = function toggleText(text) {
  return text === TEXT.READ_MORE ? TEXT.READ_LESS : TEXT.READ_MORE;
};

/**
 * Toggles the visibility of an element and updates its aria-hidden attribute.
 * @param {HTMLElement} element - The element to toggle.
 */
var toggleElementVisibility = function toggleElementVisibility(element) {
  if (!element) return;
  element.classList.toggle(CLASSES.HIDDEN);
  element.setAttribute(ATTRIBUTES.ARIA_HIDDEN, element.classList.contains(CLASSES.HIDDEN));
};

/**
 * Checks if mobile view is active.
 * @returns {boolean} True if mobile view is active.
 */
var isMobileView = function isMobileView() {
  return window.matchMedia('(max-width: 767px)').matches;
};

/**
 * Manages the "Read more/Read less" functionality for a multi-column layout.
 */
var Multicolumn = /*#__PURE__*/function () {
  /**
   * Creates an instance of Multicolumn.
   * Initializes the read more triggers.
   */
  function Multicolumn() {
    var _this = this;
    _classCallCheck(this, Multicolumn);
    /**
     * Handles the click event on the "Read More" button.
     * This method manages the visibility of content and updates the UI accordingly.
     * @param {Event} e - The click event object.
     */
    _defineProperty(this, "handleReadMoreClick", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var _this$getTriggerAndTa = _this.getTriggerAndTargetId(e),
        trigger = _this$getTriggerAndTa.trigger,
        targetId = _this$getTriggerAndTa.targetId;
      if (!trigger || !targetId) {
        console.error('Target ID not found on trigger element');
        return;
      }
      var targetElement = _this.getTargetElement(targetId);
      var truncateElement = _this.getTruncateElement(targetId);
      if (!targetElement || !truncateElement) {
        console.error('Target or truncate element not found');
        return;
      }
      if (isMobileView()) {
        _this.handleMobileView(targetElement, truncateElement, trigger, targetId);
      } else {
        _this.handleDesktopView(targetElement, truncateElement, trigger);
      }
    });
    this.readMoreTriggers = document.querySelectorAll(SELECTORS.TRIGGER);
    this.readmoreModalOpen = false;
  }
  return _createClass(Multicolumn, [{
    key: "getTriggerAndTargetId",
    value:
    /**
     * Retrieves the trigger element and the target ID from the event.
     * @param {Event} e - The click event object.
     * @returns {Object} An object containing the trigger element and target ID.
     */
    function getTriggerAndTargetId(e) {
      var trigger = e.target;
      var targetId = trigger.getAttribute(ATTRIBUTES.TRIGGER);

      // If the target doesn't have the trigger attribute, check its parent and grandparent
      if (!targetId) {
        var parent = trigger.parentElement;
        var grandparent = parent.parentElement;
        if (parent.getAttribute(ATTRIBUTES.TRIGGER)) {
          targetId = parent.getAttribute(ATTRIBUTES.TRIGGER);
          trigger = parent;
        } else if (grandparent.getAttribute(ATTRIBUTES.TRIGGER)) {
          targetId = grandparent.getAttribute(ATTRIBUTES.TRIGGER);
          trigger = grandparent;
        }
      }
      return {
        trigger: trigger,
        targetId: targetId
      };
    }

    /**
     * Retrieves the target element based on the given target ID.
     * @param {string} targetId - The ID of the target element.
     * @returns {HTMLElement|null} The target element or null if not found.
     */
  }, {
    key: "getTargetElement",
    value: function getTargetElement(targetId) {
      // Try to find the element with the exact ID, if not found, look for the mobile version
      return document.getElementById(targetId) || document.getElementById("".concat(targetId, "--mobile"));
    }

    /**
     * Retrieves the truncate element based on the given target ID.
     * @param {string} targetId - The ID of the target element.
     * @returns {HTMLElement|null} The truncate element or null if not found.
     */
  }, {
    key: "getTruncateElement",
    value: function getTruncateElement(targetId) {
      // Remove '--mobile' suffix if present before querying
      return document.querySelector("[".concat(ATTRIBUTES.TRUNCATE, "=\"").concat(targetId.replace('--mobile', ''), "\"]"));
    }

    /**
     * Handles the "Read More" functionality for mobile view.
     * @param {HTMLElement} targetElement - The target element to be shown/hidden.
     * @param {HTMLElement} truncateElement - The truncate element to be toggled.
     * @param {HTMLElement} trigger - The trigger element that was clicked.
     * @param {string} targetId - The ID of the target element.
     */
  }, {
    key: "handleMobileView",
    value: function handleMobileView(targetElement, truncateElement, trigger, targetId) {
      var mobileTargetElement = document.getElementById("".concat(targetId, "--mobile")) || targetElement;
      toggleElementVisibility(mobileTargetElement);
      toggleElementVisibility(truncateElement);
      if (!this.readmoreModalOpen) {
        // Open the modal
        document.body.appendChild(mobileTargetElement);
        this.readmoreModalOpen = true;
      } else {
        // Close the modal
        trigger = document.querySelector("[js-trigger=\"".concat(trigger.getAttribute('js-trigger').replace('--mobile', ''), "\"]"));
        this.readmoreModalOpen = false;
      }

      // Toggle body overflow and update trigger text
      document.body.classList.toggle('overflow-hidden');
      trigger.textContent = toggleText(trigger.textContent);
    }

    /**
     * Handles the "Read More" functionality for desktop view.
     * @param {HTMLElement} targetElement - The target element to be shown/hidden.
     * @param {HTMLElement} truncateElement - The truncate element to be toggled.
     * @param {HTMLElement} trigger - The trigger element that was clicked.
     */
  }, {
    key: "handleDesktopView",
    value: function handleDesktopView(targetElement, truncateElement, trigger) {
      // Simply toggle visibility and update trigger text
      toggleElementVisibility(targetElement);
      toggleElementVisibility(truncateElement);
      trigger.textContent = toggleText(trigger.textContent);
    }

    /**
     * Initializes the Multicolumn functionality by adding event listeners to triggers.
     */
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      this.readMoreTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', _this2.handleReadMoreClick);
      });
    }
  }]);
}();
/**
 * Initializes the Multicolumn functionality when the DOM is ready.
 */
var initMulticolumn = function initMulticolumn() {
  var multicolumn = new Multicolumn();
  multicolumn.init();
};

// Check if the DOM is already loaded, otherwise wait for the DOMContentLoaded event
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMulticolumn);
} else {
  initMulticolumn();
}
/******/ })()
;